function loadScript(url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = url
      script.async = true
      script.onload = () => resolve(url)
      script.onerror = () => reject(new Error(`Failed to load script: ${url}`))
      document.head.appendChild(script)
    })
  }
  
  export async function initialize(scriptsUrls, type, setMobilePay) {
    try {
      while (scriptsUrls?.length > 0) {
        const url = scriptsUrls?.shift()
        // Load the script
        await loadScript(url)
      }
      if(setMobilePay){
        setMobilePay(type)
      }
    } catch (error) {
      console.error('Error loading scripts:', error)
    }
  }
  